class FetchClient {
  constructor (src = {}) {
    this.baseUrl = src.baseUrl || ''
    this.headers = src.headers || {}
  }

  request (path, init = {}) {
    const config = {
      method: init.method,
      headers: { ...this.headers, ...init.headers }
    }

    if (init.body && typeof init.body === 'string') {
      config.body = init.body
    } else if (init.body) {
      config.body = JSON.stringify(init.body)
    }

    return fetch(`${this.baseUrl}${path}`, config).then((res) => {
      if (!res.ok) {
        throw new Error(`Error ${res.status}: ${res.text}`)
      }
      const contentType = res.headers.get('Content-Type')
      if (contentType && contentType.includes('application/json')) {
        return res.json()
      }
      return res.text()
    })
  }

  async get (url, headers = {}) {
    return this.request(url, { method: 'GET', headers })
  }

  async post (url, body, headers = {}) {
    return this.request(url, { method: 'POST', headers, body })
  }
}

module.exports = FetchClient
